// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__10F-p","content":"LoadingAlert_content__kOzz2"};